import React, { PropsWithChildren, useMemo, useState } from 'react';
import { Layout as AntLayout } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import Sidebar from './Sidebar';
import { useDevice } from '@/hooks';
import Headerbar from './Headerbar';
import './index.less';

const { Content } = AntLayout;

const siderWidth = 80;
const headerHeight = 56;

const AppLayout: React.FC<PropsWithChildren> = ({ children }) => {
    const curTheme = useSelector((state: RootState) => state.theme);
    const [ isSiderOpen, setIsSiderOpen ] = useState(false);
    const layoutMode = useDevice();

    const siderBarWidth = useMemo(() => {
        if (layoutMode.isMobile) {
            return isSiderOpen ? 286 : 0;
        }

        return siderWidth;
    }, [ layoutMode.isMobile, isSiderOpen ]);

    const headerBarHeight = useMemo(() => {
        if (layoutMode.isMobile) {
            return headerHeight;
        }

        return 0;
    }, [ layoutMode.isMobile ]);

    const systemBg = useMemo(() => {
        switch (curTheme) {
            case 'light-blue_':
                return <div
                    className="bg-light-blue"
                    style={{
                        width: '100%',
                        height: `calc(100dvh - ${headerBarHeight}px)`
                    }}
                ></div>;
            default:
                return undefined;
        }
    }, [ curTheme, layoutMode, siderBarWidth, headerBarHeight ]);

    const onSiderOpenChange = () => {
        setIsSiderOpen(!isSiderOpen);
    };

    return (
        <AntLayout
            hasSider={true}
            className={`chat-layout ${curTheme}-chat-layout`}
            style={{
                width: '100%',
                height: '100dvh'
            }}
        >
            <Sidebar width={siderBarWidth} />
            <AntLayout>
                {layoutMode.isMobile && (
                    <Headerbar
                        menuOpen={isSiderOpen}
                        height={headerHeight}
                        onMenuOpenChange={onSiderOpenChange}
                    />
                )}
                <Content className="main-content">
                    {systemBg}
                    <div
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: `calc(100dvh - ${headerBarHeight}px)`
                        }}
                    >
                        {children}
                    </div>
                </Content>
            </AntLayout>
        </AntLayout>
    );
};

export default AppLayout;
